import { useTranslation } from 'react-i18next'
import { Select } from '@radix-ui/themes'
import { Resolution, resolutionSchema } from '@willie/schemas'

const RESOLUTIONS = resolutionSchema._def.innerType.options

type Props = {
  defaultResolution?: Resolution
  onChange?: (resolution: Resolution) => void
  color?: Select.ContentProps['color']
  omit?: Resolution[]
} & Omit<Select.RootProps, 'onValueChange' | 'value' | 'defaultValue'>

const ResolutionSelector = ({ defaultResolution = 'day', onChange, color, ...selectProps }: Props) => {
  const { t } = useTranslation('common')

  const handleChange = (value: string) => {
    onChange?.(value as Resolution)
  }

  const availableResolutions = RESOLUTIONS.filter((resolution) => !selectProps.omit?.includes(resolution))

  return (
    <Select.Root size={'3'} defaultValue={defaultResolution} onValueChange={handleChange} {...selectProps}>
      <Select.Trigger />
      <Select.Content color={color ?? 'gray'} variant="soft" position="popper">
        {availableResolutions.map((resolution) => (
          <Select.Item key={resolution} value={resolution}>
            {t(resolution)}
          </Select.Item>
        ))}
      </Select.Content>
    </Select.Root>
  )
}

export default ResolutionSelector
